import { CartAddEvent } from '@theme/events';

// Quick-add size buttons on product card hover overlays.
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element && event.target.closest('[data-quick-add-variant-id]');
  if (!button || button.hasAttribute('disabled')) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = button.getAttribute('data-quick-add-variant-id');
  if (!variantId) return;

  button.setAttribute('aria-busy', 'true');

  // Show the confirmation immediately. cart/add.js takes about a second on this
  // store, and waiting on it made the tick feel broken. If the add fails we
  // fire the matching failure event below and the card puts the size back.
  button.dispatchEvent(new CustomEvent('forcast:quick-added', { bubbles: true, detail: { variantId } }));

  // Open the bag now, not when the add returns. The drawer's own auto-open runs
  // off CartAddEvent, which is dispatched after the round trip — so the bag used
  // to sit closed for the whole second the request takes, which is the bulk of
  // the delay between clicking a size and seeing anything happen. The drawer
  // shows the cart as it stands and morphs in the new line when the response
  // lands (it already carries the rendered section).
  //
  // Optional chaining throughout: there is no drawer on /cart, where these same
  // buttons appear on the Complete the look cards.
  /** @type {any} */ (document.querySelector('cart-drawer-component'))?.open?.();

  const failed = () =>
    button.dispatchEvent(new CustomEvent('forcast:quick-add-failed', { bubbles: true, detail: { variantId } }));

  try {
    // Ask for the cart drawer's section HTML in the same call. Without this the
    // add costs three sequential requests before the bag shows the item:
    // cart/add.js, then cart.js, then cart-items-component re-fetching its
    // section. Shopify renders the section into this response, so the drawer can
    // morph as soon as the add returns.
    const sectionId = document.querySelector('cart-items-component')?.dataset.sectionId;
    const payload = { id: Number(variantId), quantity: 1 };
    if (sectionId) payload.sections = sectionId;

    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const result = await response.json();

    if (result.status) {
      console.error('Quick add failed:', result.message);
      failed();
      return;
    }

    button.dispatchEvent(
      new CartAddEvent(result, variantId, {
        source: 'quick-add-sizes',
        itemCount: 1,
        variantId,
        // Hand over the freshly rendered section so the drawer morphs straight
        // away instead of fetching it again.
        sections: result.sections,
        // The button's own product id, not the card's: swatch hover re-points
        // the buttons at a combined-listing sibling while the card element
        // still carries the listing's default product id.
        productId:
          button.getAttribute('data-quick-add-product-id') ??
          button.closest('[data-product-id]')?.getAttribute('data-product-id') ??
          undefined,
      })
    );
  } catch (error) {
    console.error('Quick add failed:', error);
    failed();
  } finally {
    button.removeAttribute('aria-busy');
  }
}, true);
